"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ui = require("@alycecom/ui");

var _material = require("@mui/material");

var _react = _interopRequireDefault(require("react"));

var _reactHookForm = require("react-hook-form");

var _gifting = require("../gifting.constants");

var _gifting2 = require("../gifting.types");

var GiftActionsField = function GiftActionsField(_ref) {
  var control = _ref.control;
  return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: _gifting2.GiftActionsFields.Actions,
    control: control,
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
          value = _ref2$field.value,
          onChange = _ref2$field.onChange;
      return /*#__PURE__*/_react.default.createElement(_ui.SelectFilter, {
        name: "recipient_actions",
        label: "Recipient will be able to",
        value: value,
        onFilterChange: function onFilterChange(e) {
          return onChange(e.recipient_actions);
        },
        fullWidth: true,
        margin: "normal",
        renderItems: function renderItems() {
          return _gifting.GIFT_ACTIONS_LIST.map(function (action) {
            return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
              key: action.id,
              value: action.id
            }, action.label);
          });
        }
      });
    }
  });
};

var _default = GiftActionsField;
exports.default = _default;